exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#image-upload{border:1px dashed #ccc;height:100%;line-height:135px}#image-upload .dz-message{color:#b5b5b5}", ""]);

// exports
